import { Box, Dialog, Grid } from "@mui/material";
import { useEffect, useState } from "react";


import * as yup from "yup";
import { Field, Form, Formik } from "formik";
import { mixed, number, string } from "yup";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";

import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import { AddOrganizationCommand, Organization } from "../api/models/schema";
import { StandardTextBox } from "../common/standardTextBox";
import { StandardDropDown } from "../common/standardDropDown";

const mailPayMethodDropDownItem = [
  { id: "IMPRINT", name: "IMPRINT" },
  { id: "METER", name: "METER" },
  { id: "STAMP", name: "STAMP" }
];

export interface FormValues {
  name: string;
  email: string;
  pafid: string;
  mailingPermitId: number;
  permitNumber: string;
  customerRegistrationId: string;
  intelligentBarCodeMailerId: string;
  nonProfitAuthorizationNumber: string;
  mailPayMethod:string;
  netPostageDuePermitNumber:string;
  mailingPermitName: string;
  companyName: string;
  addressLine1: string;
  city: string;
  state: string;
  zip: string;
  phone: string;
}

const validationSchema = yup.object({
  name: string().min(5, "too short").required("required"),
  email: string().min(2, "too short").required("required"),
  //pafid: mixed().required("required"),
  //customerRegistrationId: mixed().required("required"),
  // intelligentBarCodeMailerId: mixed().required("required"),
  mailingPermitName: string().required("required"),
  // companyName: string().required("required"),
  addressLine1: string().required("required"),
  city: string().required("required"),
  state: string().required("required"),
  //zip: string().required("required"),
  //phone: string().required("required"),
});

export interface AddOrganizationFormProps {
  organization?: Organization;
  adminUserName: string;
  errorMessage?: string;
  open: boolean;
  onClose: () => void;
  onUpdate: (org: AddOrganizationCommand) => void;
}

export function AddOrganizationForm(props: AddOrganizationFormProps) {
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  useEffect(() => {
    if (props.errorMessage) {
      setErrorMessage(props.errorMessage);
      setIsLoading(false);
    }
  }, [props.errorMessage]);

  function update(values: FormValues) {
    const updateOrg: AddOrganizationCommand = {
      name: values.name,
      email: values.email,
      pafid: values.pafid,
      adminAppUser: props.adminUserName,
      mailingPermit: {
        mailingPermitId: values.mailingPermitId,
        permitNumber: values.permitNumber,
        customerRegistrationId: values.customerRegistrationId,
        intelligentBarCodeMailerId: values.intelligentBarCodeMailerId,
        name: values.mailingPermitName,
        companyName: values.name,
        addressLine1: values.addressLine1,
        city: values.city,
        state: values.state,
        zip: values.zip,
        phone: values.phone,
        nonProfitAuthorizationNumber: values.nonProfitAuthorizationNumber,
        mailPayMethod:values.mailPayMethod,
        netPostageDuePermitNumber:values.netPostageDuePermitNumber
      },
    };

    setIsLoading(true);
    setErrorMessage("");
    props.onUpdate(updateOrg);
  }

  function handleClose() {
    props.onClose();
  }

  function displayForm() {
    return (
      <Box>
        <Dialog open={props.open}>
          <DialogTitle>Add Organization</DialogTitle>
          <DialogContent>
            <Formik
              initialValues={
                props.organization
                  ? {
                      name: props.organization.name,
                      mailingPermitId:
                        props.organization.mailingPermit.mailingPermitId,
                      email: props.organization.email,
                      pafid: props.organization.pafid,
                      permitNumber:
                        props.organization.mailingPermit.permitNumber,
                      customerRegistrationId:
                        props.organization.mailingPermit.customerRegistrationId,
                      intelligentBarCodeMailerId:
                        props.organization.mailingPermit
                          .intelligentBarCodeMailerId,
                      mailingPermitName: props.organization.mailingPermit.name,
                      companyName: props.organization.mailingPermit.companyName,
                      addressLine1:
                        props.organization.mailingPermit.addressLine1,
                      city: props.organization.mailingPermit.city,
                      state: props.organization.mailingPermit.state,
                      zip: props.organization.mailingPermit.zip,
                      phone: props.organization.mailingPermit.phone,
                      nonProfitAuthorizationNumber:props.organization.mailingPermit.nonProfitAuthorizationNumber,
                      mailPayMethod:props.organization.mailingPermit.mailPayMethod,
                      netPostageDuePermitNumber:props.organization.mailingPermit.netPostageDuePermitNumber
                    }
                  : {
                      name: "",
                      email: "",
                      pafid: "",
                      permitNumber: "",
                      mailingPermitId: 0,
                      customerRegistrationId: "",
                      intelligentBarCodeMailerId: "",
                      mailingPermitName: "",
                      companyName: "",
                      addressLine1: "",
                      city: "",
                      state: "",
                      zip: "",
                      phone: "",
                      nonProfitAuthorizationNumber:"",
                      mailPayMethod:"",
                      netPostageDuePermitNumber:""
                    }
              }
              validationSchema={validationSchema}
              onSubmit={(values, { setSubmitting }) => {
                // alert("submitting the form with values");
                console.log(`submitting the form with values`);

                setSubmitting(false);
                update(values);
              }}
            >
              {({ submitForm,setFieldValue, isSubmitting }) => (
                <Form>
                  <br />

                  <Grid container spacing={2}>
                    <Grid item xs={3}>
                      Organization Name
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="name"
                        label="Organization Name"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Email
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="email"
                        label="Email"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      PafId
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="pafid"
                        label="PafId"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Permit Number
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="permitNumber"
                        label="Permit Number"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Permit Name
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="mailingPermitName"
                        label="Permit Name"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      CRID
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="customerRegistrationId"
                        label="Customer Registration Id"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      IMBD
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="intelligentBarCodeMailerId"
                        label="Intelligent BarCode Mailer Id"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Non Profit #
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="nonProfitAuthorizationNumber"
                        label="Non Profit #"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Mail Pay Method
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardDropDown}
                        name="mailPayMethod"
                        label="Mail Pay Method"
                        items={mailPayMethodDropDownItem}
                        width={375}
                        onChange={(e: any) => {
                          setFieldValue("mailPayMethod", e.target.value);
                        }}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Postage Due Permit #
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="netPostageDuePermitNumber"
                        label="Postage Due Permit #"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      Address
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="addressLine1"
                        label="Address"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      City
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="city"
                        label="City"
                        width={375}
                      />
                    </Grid>

                    <Grid item xs={3}>
                      State
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="state"
                        label="State"
                        width={375}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      Zip
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="zip"
                        label="Zip"
                        width={375}
                      />
                    </Grid>
                    <Grid item xs={3}>
                      Phone
                    </Grid>
                    <Grid item xs={9}>
                      <Field
                        component={StandardTextBox}
                        name="phone"
                        label="Phone"
                        width={375}
                      />
                    </Grid>

                    <Grid
                      spacing={2}
                      item
                      container
                      xs={12}
                      justifyContent="flex-end"
                    >
                      {!isLoading && (
                        <Grid item>
                          <Button variant="contained" onClick={submitForm}>
                            Save
                          </Button>
                        </Grid>
                      )}
                      {isLoading && (
                        <Grid item>
                          <CircularProgress />
                        </Grid>
                      )}
                      <Grid item>
                        <Button onClick={handleClose}>Cancel</Button>
                      </Grid>
                    </Grid>

                    <Grid item xs={12}>
                      {errorMessage && <p>{errorMessage}</p>}
                    </Grid>
                  </Grid>
                </Form>
              )}
            </Formik>
          </DialogContent>
        </Dialog>
      </Box>
    );
  }

  return <>{displayForm()}</>;
}
